import axios from 'axios';

const getHeaders = () => {
    return {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };
};

export default axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URI,
    headers: getHeaders(),
});
